var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:{
  'status-span-center':!(_vm.aggregated_status.reason)
}},[_c('span',{staticClass:"status-span",class:{
      'text-green-600':
        _vm.aggregated_status.status == 'Delivering',
      'text-red-600':
        _vm.aggregated_status.status == 'Not Delivering'
    }},[_vm._v("\n    "+_vm._s(_vm.aggregated_status.status)+"\n  ")]),(_vm.aggregated_status.reason !== '')?_c('span',{staticClass:"status-span"},[_vm._v("\n    "+_vm._s(_vm.aggregated_status.reason)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }